import OrdersList from './OrdersList';

export default OrdersList;
